import { useEffect } from 'react'
import { toast } from 'sonner'

import {
  markAsDisplayed,
  removeNotification,
  selectPendingNotifications,
  useAppDispatch,
  useAppSelector,
} from '@/store'

export function GlobalNotificationManager() {
  const dispatch = useAppDispatch()
  const pendingNotifications = useAppSelector(selectPendingNotifications)

  useEffect(() => {
    pendingNotifications.forEach((notification) => {
      const duration =
        notification.duration ?? (notification.type === 'error' ? 5000 : 3000)

      const options = {
        description: notification.description,
        duration,
      }

      switch (notification.type) {
        case 'success':
          toast.success(notification.title, options)
          break
        case 'error':
          toast.error(notification.title, options)
          break
        case 'warning':
          toast.warning(notification.title, options)
          break
        case 'info':
          toast.info(notification.title, options)
          break
        default:
          toast(notification.title, options)
      }

      dispatch(markAsDisplayed(notification.id))

      setTimeout(() => {
        dispatch(removeNotification(notification.id))
      }, duration + 1000)
    })
  }, [pendingNotifications, dispatch])

  return null
}
